import React from "react";

import { useTranslation } from "utils";

import { Drawer } from "components";

import { FieldDetails } from "pages/app/fields/components/FieldDetails";

export const FieldReviewDrawer = ({ fieldId, visible, onClose }: { fieldId: string; visible: boolean; onClose: () => void }) => {
  const { t } = useTranslation("farm");

  return (
    <Drawer title={t("fieldReviewDrawer.title")} visible={visible} onClose={onClose}>
      <div className="margin-top-200">
        <FieldDetails fieldId={fieldId} review={true} onReviewFinish={onClose} />
      </div>
    </Drawer>
  );
};
